
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leadership",
      function () {
        return require("private-next-pages/leadership.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leadership"])
      });
    }
  